// Страница входа: JWT + опциональная 2FA.
import { useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { getErrorMessage } from '@/api';
import { Button } from '@/components/ui/Button';
import './auth.css';

export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [needOtp, setNeedOtp] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password, needOtp ? otp : undefined);
      navigate('/');
    } catch (err) {
      const data = (err as { response?: { data?: Record<string, unknown> } }).response?.data;
      if (data?.otp_required) {
        setNeedOtp(true);
        setError('Введите код из приложения-аутентификатора');
      } else {
        setError(getErrorMessage(err));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-bg" />
      <form className="auth-card" onSubmit={onSubmit}>
        <div className="auth-logo">
          <span className="auth-logo__mark">S</span>
          <span className="auth-logo__text">STRUXIS</span>
        </div>
        <p className="auth-subtitle">Платформа управления капитальным ремонтом</p>
        <div className="field">
          <label className="field__label">Email</label>
          <input className="field__input" type="email" value={email}
            onChange={(e) => setEmail(e.target.value)} placeholder="you@company.ru" required autoFocus />
        </div>
        <div className="field">
          <label className="field__label">Пароль</label>
          <input className="field__input" type="password" value={password}
            onChange={(e) => setPassword(e.target.value)} placeholder="••••••••••••" required />
        </div>
        {needOtp && (
          <div className="field">
            <label className="field__label">Код двухфакторной аутентификации</label>
            <input className="field__input" value={otp} onChange={(e) => setOtp(e.target.value)}
              placeholder="000000" inputMode="numeric" maxLength={6} autoFocus />
          </div>
        )}
        {error && <div className="auth-error">{error}</div>}
        <Button type="submit" variant="primary" disabled={loading} style={{ width: '100%' }}>
          {loading ? 'Вход…' : 'Войти'}
        </Button>
        <p className="auth-foot">Нет аккаунта? Регистрация только по приглашению от администратора компании.</p>
      </form>
    </div>
  );
}
